import { Component, DestroyRef, NgZone, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { ConfirmDialogComponent } from '@kinet-open-network/client/core/forms/ui';
import { ToastComponent, toast } from '@kinet-open-network/client/shared/ui';
import { Translation } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { filter, interval } from 'rxjs';
import * as primengLocale from '../assets/i18n/sk/primeng.json';

@Component({
  imports: [RouterModule, ToastComponent, ConfirmDialogComponent],
  selector: 'kon-root',
  template: `
    <router-outlet />
    <kon-toasts></kon-toasts>
    <kon-confirm-dialog> </kon-confirm-dialog>
  `,
})
export class AppComponent implements OnInit {
  private primengConfig = inject(PrimeNG);
  private swUpdate = inject(SwUpdate);
  private ngZone = inject(NgZone);
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.setPrimeNgLocale();
    this.addTableFilterMatchModes();
    this.setupSwUpdate();
  }

  setPrimeNgLocale() {
    this.primengConfig.setTranslation(primengLocale as Translation);
  }

  private setupSwUpdate() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          filter(
            (evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY',
          ),
        )
        .subscribe(() =>
          toast({
            summary: 'Je dostupná nová verzia aplikácie.',
            detail:
              'Pre správne fungovanie aplikácie odporúčame aktualizovať na najnovšiu verziu',
            sticky: true,
            severity: 'info',
            closable: false,
            actions: [
              {
                label: 'Aktualizovať',
                command: () => {
                  document.location.reload();
                },
              },
            ],
          }),
        );

      this.ngZone.runOutsideAngular(() =>
        interval(2 * 60000)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => this.swUpdate.checkForUpdate()),
      );
    }
  }

  private addTableFilterMatchModes() {
    this.primengConfig.filterMatchModeOptions.date.push('present');
    this.primengConfig.filterMatchModeOptions.text.push('present');
    this.primengConfig.filterMatchModeOptions.numeric.push('present');
  }
}
